﻿import { RefObject } from 'react';
import { DsSliderHandle } from './Types';

export const goToSlide = (sliderRef: RefObject<DsSliderHandle | null> | null, index: number) => {
  if (!sliderRef?.current) return;
  sliderRef.current.goToSlide(index);
};